module.exports = __webpack_public_path__ + "assets/dd329b75926dd3099f75d70e30bf5dc6.png";